import React from 'react';

const SearchIcon = props => (
	<svg width="22" height="22" viewBox="0 0 22 22" {...props}>
		<path d="M16.318 8.66a7.659 7.659 0 1 1-15.317 0 7.659 7.659 0 1 1 15.317 0zM21 21l-6.925-6.925"/>
	</svg>
);

export default SearchIcon;
